<!--
/*******************************************************************************
*@ 컴포넌트명   : ChooseSiteInfo.vue
*@ 컴포넌트설명 : 국가, 언어 선택
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <section class="main setting">
    <popup :opened.sync="openData" :use-header="true" :use-footer="true" :btn-area-padding="true">
      <template #content>
        <div class="setting-tit">
          <template v-if="step == 1">
            <span>
              Choose
              <br />your </span
            >country
          </template>
          <template v-else>
            <span>
              Choose
              <br />your </span
            >language
          </template>
        </div>
        <!-- form-check-group -->
        <div class="form-check-group --type3 right">
          <template v-if="step == 1">
            <!-- <div class="form-row">
              <div class="form-check">
                <input
                  type="radio"
                  :id="`siteCode_${$config.SITECODE_OGAUC}`"
                  name="siteCode"
                  :value="$config.SITECODE_OGAUC"
                  v-model="selectedSiteCodeData"
                  class="form-check-input"
                />
                <label :for="`siteCode_${$config.SITECODE_OGAUC}`" class="form-check-label">
                  <i class="icon icon-nation-nz" />
                  New Zealand
                </label>
              </div>
            </div> -->
            <!-- <div class="form-row">
              <div class="form-check">
                <input
                  type="radio"
                  :id="`siteCode_${$config.SITECODE_OGCBD}`"
                  name="siteCode"
                  :value="$config.SITECODE_OGCBD"
                  v-model="selectedSiteCodeData"
                  class="form-check-input"
                />
                <label :for="`siteCode_${$config.SITECODE_OGCBD}`" class="form-check-label">
                  <i class="icon icon-nation-cam" />
                  Cambodia
                </label>
              </div>
            </div> -->
            <div class="form-row">
              <div class="form-check">
                <input
                  type="radio"
                  :id="`siteCode_${$config.SITECODE_OGMMR}`"
                  name="siteCode"
                  :value="$config.SITECODE_OGMMR"
                  v-model="selectedSiteCodeData"
                  class="form-check-input"
                />
                <label :for="`siteCode_${$config.SITECODE_OGMMR}`" class="form-check-label">
                  <i class="icon icon-nation-mm" />
                  Myanmar
                </label>
              </div>
            </div>
            <div class="form-row">
              <div class="form-check">
                <input
                  type="radio"
                  :id="`siteCode_${$config.SITECODE_OGHCM}`"
                  name="siteCode"
                  :value="$config.SITECODE_OGHCM"
                  v-model="selectedSiteCodeData"
                  class="form-check-input"
                />
                <label :for="`siteCode_${$config.SITECODE_OGHCM}`" class="form-check-label">
                  <i class="icon icon-nation-vn" />
                  Vietnam
                </label>
              </div>
            </div>
            <!-- 추후 오픈 - 인도 -->
            <!-- <div class="form-row">
              <div class="form-check">
                <input
                  type="radio"
                  :id="`siteCode_${$config.SITECODE_OGIND}`"
                  name="siteCode"
                  :value="$config.SITECODE_OGIND"
                  v-model="selectedSiteCodeData"
                  class="form-check-input"
                />
                <label :for="`siteCode_${$config.SITECODE_OGIND}`" class="form-check-label">
                  <i class="icon icon-nation-ind" />
                  India
                </label>
              </div>
            </div>-->
          </template>
          <template v-else>
            <div class="form-row" v-for="(data, i) in siteLangList" :key="i">
              <div class="form-check">
                <input type="radio" :id="`lang_${data.lang}`" name="lang" class="form-check-input" v-model="selectedLangCode" :value="data.lang" />
                <label :for="`lang_${data.lang}`" class="form-check-label">
                  <i class="icon" :class="`icon-nation-${data.icon}`" />
                  {{ data.text }}
                </label>
              </div>
            </div>
          </template>
        </div>
        <!--// form-check-group end  -->
      </template>
      <template #footer>
        <template v-if="step == 1">
          <button class="btn md normal" @click="selectedCtr">{{ /*다음*/ $t("MCOM-0000034") }}</button>
        </template>
        <template v-else>
          <button class="btn md gray" @click="goPrev">{{ /*이전*/ $t("MCOM-0000033") }}</button>
          <button class="btn md normal" @click="selectedLang">{{ /*완료*/ $t("MCOM-0000106") }}</button>
        </template>
      </template>
    </popup>
    <update-popup ref="versionUpdate" />
  </section>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import UpdatePopup from "@/components/layout/VersionUpdatePopup";

export default {
  name: "ChooseSiteInfo",
  components: {
    UpdatePopup,
  },
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapFields(["siteCode", "lang", "operGroupCd"]),
    siteLangList: {
      get() {
        if (this.selectedSiteCodeData == this.$config.SITECODE_OGCBD) return this.langList[this.$config.SITECODE_OGCBD];
        else if (this.selectedSiteCodeData == this.$config.SITECODE_OGMMR) return this.langList[this.$config.SITECODE_OGMMR];
        else if (this.selectedSiteCodeData == this.$config.SITECODE_OGAUC) return this.langList[this.$config.SITECODE_OGAUC];
        else if (this.selectedSiteCodeData == this.$config.SITECODE_OGHCM) return this.langList[this.$config.SITECODE_OGHCM];
        else if (this.selectedSiteCodeData == this.$config.SITECODE_OGIND) return this.langList[this.$config.SITECODE_OGIND];
        else return this.langList.etc;
      },
    },
    openData: {
      get() {
        if (this.opened) {
          if (!_.isEmpty(this.siteCode)) {
            this.setSelectedSiteCode(this.siteCode);
          } else {
            this.setSelectedSiteCode(this.$config.SITECODE_OGMMR);
          }
        }
        return this.opened;
      },
      set(value) {
        this.step = 1;
        this.selectedSiteCodeData = this.siteCode;
        this.$emit("update:opened", value);
      },
    },
    selectedSiteCodeData: {
      get() {
        return this.selectedSiteCode;
      },
      set(value) {
        this.selectedSiteCode = value;
      },
    },
  },
  created() {},
  data() {
    return {
      step: 1,
      selectedSiteCode: "",
      selectedLangCode: "",
      langList: {
        ogcbd: [
          { lang: "KOR", text: "Korean", icon: "kr" },
          { lang: "ENG", text: "English", icon: "us" },
          { lang: "KHM", text: "Cambodian", icon: "cam" },
        ],
        ogmmr: [
          { lang: "KOR", text: "Korean", icon: "kr" },
          { lang: "ENG", text: "English", icon: "us" },
          { lang: "MMR", text: "Burmese", icon: "mm" },
        ],
        ogauc: [
          { lang: "KOR", text: "Korean", icon: "kr" },
          { lang: "ENG", text: "English", icon: "us" },
        ],
        ogvtn: [
          { lang: "KOR", text: "Korean", icon: "kr" },
          { lang: "ENG", text: "English", icon: "us" },
          { lang: "VNM", text: "Vietnamese", icon: "vn" },
        ],
        ogind: [
          { lang: "KOR", text: "Korean", icon: "kr" },
          { lang: "ENG", text: "English", icon: "us" },
        ],
        etc: [
          { lang: "KOR", text: "Korean", icon: "kr" },
          { lang: "ENG", text: "English", icon: "us" },
        ],
      },
    };
  },
  methods: {
    ...mapActions(["actSiteCode"]),
    ...mapActions("common/main", ["ACT_setLatestNews"]),
    initLang() {
      if (this.siteCode != this.selectedSiteCodeData) {
        this.selectedLangCode = this.siteLangList[1].lang;
      } else {
        this.selectedLangCode = this.lang;
      }
    },
    selectedCtr() {
      //베트남 NAPAS QR 버전 업데이트 제외
      /*
      if (this.selectedSiteCodeData == this.$config.SITECODE_OGHCM && process.env.NODE_ENV != "local" && process.env.NODE_ENV != "development") {
        if (this.$refs.versionUpdate.checkVersion()) return;
      }
      */
      this.step = 2;
      this.initLang();
    },
    selectedLang() {
      this.actSiteCode(this.selectedSiteCodeData);

      this.lang = this.selectedLangCode;
      this.$i18n.locale = this.selectedLangCode;
      sessionStorage.setItem("lang", this.selectedLangCode);

      //set native data - siteCode , lang
      this.$bridge.setNativeData({ siteCode: this.selectedSiteCodeData, natCode: this.selectedLangCode });
      this.$lang();

      this.step = 1;
      this.ACT_setLatestNews(this.operGroupCd);
      this.$emit("update:opened", false);
      this.$emit("change");
    },
    goPrev() {
      this.step = 1;
    },
    setSelectedSiteCode(code) {
      this.selectedSiteCodeData = code;
    },
  },
};
</script>
